import { render, staticRenderFns } from "./AccountLogin.vue?vue&type=template&id=35c7f076&scoped=true&"
import script from "./AccountLogin.vue?vue&type=script&lang=js&"
export * from "./AccountLogin.vue?vue&type=script&lang=js&"
import style0 from "./AccountLogin.vue?vue&type=style&index=0&id=35c7f076&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c7f076",
  null
  
)

export default component.exports